import { render, staticRenderFns } from "./CreatorBonusIndex.vue?vue&type=template&id=c2534c2c&"
import script from "./CreatorBonusIndex.vue?vue&type=script&lang=js&"
export * from "./CreatorBonusIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports